import React, { useEffect, useState } from "react";
import MonitorUserStatArea from "./monitorUserStatArea";
import MonitorUserStatCnt from "./monitorUserStatCnt";

import "./monitorUserStat.css";
import { getDashBoardData } from "../../service/monitor/monitorUserStatService";

// 메인컴포넌트
const MonitorUserStat = ({ conn }) => {
  // 현재 보여줄 지역 동 데이터
  const dongArray = [
    { dongCode: "4413325000", dongTerm: "성환읍" },
    { dongCode: "4413325300", dongTerm: "성거읍" },
    { dongCode: "4413325600", dongTerm: "직산읍" },
    { dongCode: "4413331000", dongTerm: "입장면" },
  ];

  const [statusCnt, setStatusCnt] = useState({
    total: 0,
    normal: 0,
    warn: 0,
    danger: 0,
    unOper: 0,
    dataSource: [],
  });

  const [imgHover, setImgHover] = useState({
    isHover: false,
  });

  // 데이터 불러오기
  const getData = () => {
    // console.log("data load");
    getDashBoardData(conn, getResultCnt, getRejection);
  };

  const getResultCnt = result => {
    setStatusCnt(statusCnt => {
      const item = { ...statusCnt };
      item.total = result.totalCnt.total;
      item.normal = result.totalCnt.normal;
      item.warn = result.totalCnt.warn;
      item.danger = result.totalCnt.danger;
      item.unOper = result.totalCnt.unOper;
      item.dataSource = result.dataSource;
      return item;
    });
  };

  const getRejection = error => {};

  useEffect(() => {
    getData();
    getDataInterval();
  }, []);

  // 시간 값 TimeDelay 설정
  const getDataInterval = () => {
    setTimeout(() => {
      getData();
    }, 60000);
  };

  const handleMouseHover = () => {
    setImgHover({ isHover: !imgHover.isHover });
  };

  return (
    <>
      <MonitorUserStatCnt statusCnt={statusCnt} />
      <div>
        <span className="statusViewHelp">
          상태표시 도움말
          <img src="/images/info.png" alt="" />
          <div className="statusHelpImg">
            <span className="helpTxtLine">
              <img className="helpCircleSize" src="/images/chncareimg/icon_gre.png" alt="정상" /> 정상 : 정상적으로 데이터 수집이 되는 상태
            </span>
            <span className="helpTxtLine">
              <img className="helpCircleSize" src="/images/chncareimg/icon_yl.png" alt="경고" /> 경고 : 정상적으로 데이터 수집이 되며, 4시간 이상
              자리비움(움직임0, 호흡0){" "}
            </span>
            <span className="helpTxtLine">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;상태 지속시 </span>
            <span className="helpTxtLine">
              <img className="helpCircleSize" src="/images/chncareimg/icon_rd.png" alt="위험" /> 위험 : 정상적으로 데이터 수집이 되며, 24시간 이상
              자리비움/수면(움직임0, 호흡0){" "}
            </span>
            <span className="helpTxtLine">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;상태 지속시 </span>
            <span className="helpTxtLine">
              <img className="helpCircleSize" src="/images/chncareimg/icon_gray.png" alt="미작동" /> 미작동 : 8시간 이상 데이터 미수집 상태 지속시
            </span>
          </div>
          {/* <img className='statusHelpImg' src="/images/statusHelp.png" alt="" /> */}
        </span>
      </div>
      <div className="uk-grid">
        {dongArray.map((dong, i) => {
          return (
            <MonitorUserStatArea
              conn={conn}
              dongCode={dong.dongCode}
              dongTerm={dong.dongTerm}
              getRejection={getRejection}
              dataSource={statusCnt.dataSource}
              key={i}
            />
          );
        })}
      </div>
    </>
  );
};

export default MonitorUserStat;
